import { head } from 'ramda';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Truncated } from './components/Truncated';
import { GenericNotification } from './GenericNotification';

export const deleteBoardNotification =
  ({ boards }) =>
  ({ notification }) =>
    (
      <GenericNotification
        notification={notification}
        text={
          <FormattedMessage
            id="boards.modal.delete.notification"
            values={{
              boardsCount: boards.length,
              boardName: <Truncated>{head(boards).name}</Truncated>,
            }}
          />
        }
        dataHook="boards-delete-notification"
      />
    );
